import { getDefaultExportFromCjs } from '../../../_virtual/_commonjsHelpers.js';
import { __exports as lib } from '../../../_virtual/index3.js';
import './players/index.js';
import './ReactPlayer.js';
import { __exports as players } from '../../../_virtual/index4.js';
import { __exports as ReactPlayer$1 } from '../../../_virtual/ReactPlayer.js';

(function (exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports["default"] = void 0;
  var _players = _interopRequireDefault(players);
  var _ReactPlayer = ReactPlayer$1;
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      "default": obj
    };
  }

  // Fall back to FilePlayer if nothing else can play the URL
  var fallback = _players["default"][_players["default"].length - 1];
  var _default = (0, _ReactPlayer.createReactPlayer)(_players["default"], fallback);
  exports["default"] = _default;
})(lib);
var ReactPlayer = /*@__PURE__*/getDefaultExportFromCjs(lib);

export { ReactPlayer as default };
//# sourceMappingURL=index.js.map
